export class IPLEXGRequest {
  Request: CGIRequest;

  constructor() {
    this.Request = new CGIRequest();
  }
}

export class IPLEXGResponse<T> {
  Response: CGIResponse<T>;
}

export class CGIRequest {
  Command: string;
  Params: StartHttpsPram | RequestWifiSettingsPram | any;
}

export class CGIResponse<T> {
  Requested: string;
  Result: string;
  Data: T;
}

export class StartHttpsPram {
  User: string;
  PassPhrase: string;
  Client: string;
}

export abstract class WifiSettingsPram {
  Ssid: string;
  Security: string;
  Channel: number;
}

export class RequestWifiSettingsPram extends WifiSettingsPram {
  PassPhrase: string;
}

export class ResponseWifiSettingsPram extends WifiSettingsPram {
  Passphrase: string;
}

export class ResponseHttpsStart {
  Consent: 'Yes' | 'No' | 'Timeout';
}
